import {LinkPlugin as LexicalLinkPlugin} from '@lexical/react/LexicalLinkPlugin';

function validateUrl(possibleUrl: string) {
  const trimmed = possibleUrl.trim();

  try {
    const url = new URL(trimmed);
    return ['http:', 'https:'].includes(url.protocol);
  } catch {
    try {
      const url = new URL(`https://${trimmed}`);
      return (
        !!url.hostname &&
        url.hostname.includes('.') &&
        !url.hostname.startsWith('.') &&
        !url.hostname.endsWith('.') &&
        url.hostname.length > 0
      );
    } catch {
      return false;
    }
  }
}

type Props = {
  hasLinkAttributes?: boolean;
};

export function LinkPlugin({hasLinkAttributes = false}: Props) {
  return (
    <LexicalLinkPlugin
      validateUrl={validateUrl}
      attributes={
        hasLinkAttributes
          ? {
              rel: 'noopener noreferrer',
              target: '_blank',
            }
          : undefined
      }
    />
  );
}
